module.exports = __webpack_public_path__ + "static/media/Assembly_exploded_.20751adb.PNG";